import bowser from 'bowser';
import { Mesh } from 'three';

export function getMaxDpr(): number {
  // Lower DPI when on older phones.
  return (bowser.safari && parseFloat(`${bowser.version}`) <= 14) ||
    (bowser.android && parseFloat(`${bowser.osversion}`) <= 9)
    ? 1
    : 2;
}

export function getMinMaxDpr(): [min: number, max: number] {
  return [1, getMaxDpr()];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function disposeObject3D(object: { [key: string]: any }): void {
  Object.keys(object).forEach((key) => {
    const obj = object[key];
    if (obj instanceof Mesh) {
      if (obj.material) {
        obj.material.dispose();
        if (obj.material.map) {
          obj.material.map.dispose();
        }
        if (obj.material.lightMap) {
          obj.material.lightMap.dispose();
        }
        if (obj.material.aoMap) {
          obj.material.aoMap.dispose();
        }
        if (obj.material.emissiveMap) {
          obj.material.emissiveMap.dispose();
        }
        if (obj.material.bumpMap) {
          obj.material.bumpMap.dispose();
        }
        if (obj.material.normalMap) {
          obj.material.normalMap.dispose();
        }
        if (obj.material.displacementMap) {
          obj.material.displacementMap.dispose();
        }
        if (obj.material.roughnessMap) {
          obj.material.roughnessMap.dispose();
        }
        if (obj.material.metalnessMap) {
          obj.material.metalnessMap.dispose();
        }
        if (obj.material.alphaMap) {
          obj.material.alphaMap.dispose();
        }
        if (obj.material.envMaps) {
          obj.material.envMaps.dispose();
        }
        if (obj.material.envMap) {
          obj.material.envMap.dispose();
        }
        if (obj.material.specularMap) {
          obj.material.specularMap.dispose();
        }
        if (obj.material.gradientMap) {
          obj.material.gradientMap.dispose();
        }
      }
      if (obj.geometry) {
        obj.geometry.dispose();
      }
      // if (obj.texture && obj.texture?.dispose) {
      //   console.log('texture', obj.texture)
      //   obj.texture?.dispose();
      //   // obj.texture = {};
      // }
      // if (obj.bufferGeometry) {
      //   console.log('bufferGeometry', obj.bufferGeometry)
      //   obj.bufferGeometry.dispose();
      // }
    }
  });
}
